import { submission } from '../actions';

const {
	SUBMISSION_RESET, reset, add, SUBMISSION_ADD_ITEM, SUBMISSION_TOGGLE, toggle, remove, SUBMISSION_REMOVE, SUBMISSION_SET_DATA,
	setData, SUBMISSION_SELECT, select,
} = submission;

const INITIAL_STATE = {
	url: {},
	data: [],
	selected: [],
	focussed: null,
	itemToAdd: null,
	itemToToggle: null,
	itemToRemove: null,
};

/*
  METHODS THAT CAN BE CALLED FROM OTHER PLATFORMS:
  * TOGGLE (payload is the ID of an element)
  * REMOVE (payload is the ID to remove from the grid)
  * ADD (payload is the object that should be added and shown)

  ALL OTHER METHODS ARE USED FOR ANIMATIONS.
*/
export default function content(state = INITIAL_STATE, action) {
	switch (action.type) {
		case SUBMISSION_SET_DATA:
			return setData(action, state);
		case SUBMISSION_SELECT:
			return select(action, state);
		case SUBMISSION_ADD_ITEM:
			return add(action, state);
		case SUBMISSION_TOGGLE:
			return toggle(action, state);
		case SUBMISSION_RESET:
			return reset(state);
		case SUBMISSION_REMOVE:
			return remove(action, state);
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/submission.js